<template>
	<LayoutMain>
		<div class="navsecondary">
			<RouterLink data-ic="M" :to="{ name: 'AgreementsAllCreate'}">
				<span>Opret aftale</span>
			</RouterLink>

			<input type="search" v-model="searchinput" /><i data-ic="Q"></i>
		</div>
		<section>
			<h1>Aftaler</h1>
			<div>
				<transition name="fade">
					<RouterView v-bind:search="searchinput" />
				</transition>
			</div>
		</section>
	</LayoutMain>
</template>

<script>
	import LayoutMain from "@/components/common/LayoutMain.vue";

	export default {
		name: "Agreements",
		data()
		{
			return {
				searchinput: ""
			}
		},
		components: {
			LayoutMain
		},
	};
</script>